<template>
  <div v-show="isFolderContentViewActiveLocal">

    <ul style="margin-top: 10px;flex-wrap: wrap;">
      <div class="limit-width_fixed-scalable mb-3" style="text-align: left;">
        <li>
          <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_bg-color__blend bg-color">
                  <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button :disabled="true"
                         size="large"
                         class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                         type="filled"
                         color="">
                Select a Resource
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
      </div>
      <p v-if="resources.length == 0 && folders.length == 0">No content to display</p>

      <li v-for="(_folder, folderIndex) in folders" :key="folderIndex" class="mb-4">
        <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="FolderIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                      class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                      style="border-radius:0 7px 7px 0;"
                      @click="selectFolder(_folder)">
              {{ _folder.name }}
            </vs-button>

            <span id="manage-topic-fab" v-if="$acl.not.check('Student')">
              <div class="fab_manage-topic">
                <div class="float-btn-group">
                  <button class="btn-float btn-triger input-group_prepend-slot-bg" @click="openActions">
                    <i class="icon feather icon-more-horizontal text-white" />
                  </button>
                  <div class="btn-list">
                    <a class="btn-float dc_dark-purple description glow-effect_dark" @click="deleteFolder(_folder.id)">
                      <i class="icon feather icon-trash-2 text-danger" />
                    </a>
                    <a class="btn-float dc_dark-purple description glow-effect_dark" @click="editFolder(_folder)">
                      <i class="icon feather icon-edit text-white" />
                    </a>
                  </div>
                </div>
              </div>
            </span>
          </vx-input-group>
        </vx-card>
      </li>

      <li v-for="(_resource, resourceIndex) in resources.filter(x => !x.termId && !x.gradeId)" :key="resourceIndex + 'a'" class="mb-4">
        <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                       class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                       style="border-radius:0 7px 7px 0;"
                       @click="selectResource(_resource)">
              {{ _resource.name }}
            </vs-button>

            <span id="manage-topic-fab" v-if="$acl.not.check('Student')">
              <div class="fab_manage-topic">
                <div class="float-btn-group">
                  <button class="btn-float btn-triger input-group_prepend-slot-bg" @click="openActions">
                    <i class="icon feather icon-more-horizontal text-white" />
                  </button>
                  <div class="btn-list">
                    <a class="btn-float dc_dark-purple description glow-effect_dark" @click="deleteResource(_resource.topicId)">
                      <i class="icon feather icon-trash-2 text-danger" />
                    </a>
                    <a class="btn-float dc_dark-purple description glow-effect_dark" @click="editResource(_resource)">
                      <i class="icon feather icon-edit text-white" />
                    </a>
                  </div>
                </div>
              </div>
            </span>
          </vx-input-group>
        </vx-card>
      </li>
      
      <div v-if="$acl.not.check('Student')" >
        <li class="mb-4 mt-6">            
          <vx-card class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_primary limit-height_content-height school-primary_gradient" style="width: 65px;">
                  <span><feather-icon class="pt-1 ml-2" icon="PlusIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                id="add-standalone-content-btn"
                size="large"
                class="w-full button__fully-opaque glow-effect_primary limit-height_content-height button-text__left-align input-group_prepend-slot-bg"
                style="border-radius:0 7px 7px 0;"
                color=""
                @click="addFolder">
                Add a Folder
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
        <li>            
          <vx-card class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_primary limit-height_content-height school-primary_gradient" style="width: 65px;">
                  <span><feather-icon class="pt-1 ml-2" icon="PlusIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                id="add-standalone-content-btn"
                size="large"
                class="w-full button__fully-opaque glow-effect_primary limit-height_content-height button-text__left-align input-group_prepend-slot-bg"
                style="border-radius:0 7px 7px 0;"
                color=""
                @click="addResource">
                Add a Resource
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    isFolderContentViewActive: {
      required: false,
    },
    folders: {
      type: Array,
      required: false
    },
    resources: {
      type: Array,
      required: false
    },
  },
  data() {
    return {
      fabElement: null
    };
  },
  watch: {
    isFolderContentViewActive: function(val) {
      if(val){
        var self = this;
        
      }
    },
  },
  computed: {
    isFolderContentViewActiveLocal: {
      get() {
        return this.isFolderContentViewActive;
      }
    }
  },
  methods: {
    selectResource(resource) {
      var self = this;
      self.$emit("resourceSelected", resource);
    },
    backToSelectCategory() {
      this.$emit("backToSelectCategory");
    },
    selectFolder(folder) {
      this.$emit("folderSelected", folder);
    },
    addFolder() {
      this.$emit("addFolder");
    },
    addResource() {
      this.$emit("addResource");
    },
    editFolder(folder) {
      var self = this;
      self.closeActions();
      self.$emit("editFolder", folder);
    },
    deleteFolder(folderId) {
      var self = this;
      self.closeActions();
      self.$emit("deleteFolder", folderId)  
    },
    editResource(resource) {
      var self = this;
      self.closeActions();
      self.$emit("editResource", resource);
    },
    deleteResource(resourceId) {
      var self = this;
      self.closeActions();
      self.$emit("deleteResource", resourceId)  
    },
    openActions(e) {
      this.fabElement = e.target.closest(".float-btn-group");
      if (this.fabElement) {
        this.fabElement.classList.toggle('open')
      }
    },
    closeActions() {
      if (this.fabElement) {
        this.fabElement.classList.remove('open')
      }
    }
  }
};
</script>
<style lang="scss">
  .vs-collapse {
    h4 {
      margin-bottom: 0 !important;
    }
  }
</style>